import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getCallbackHealth } from 'services/api/getCallbackHealth';

export const useGetCallbackHealth = () => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.callbackHealth,
        queryFn: getCallbackHealth,
    });

    return { callbackHealthData: data, isCallbackHealthLoading: isLoading, ...rest };
};
